module.exports = __webpack_public_path__ + "static/media/outstanding work-01-01.07af2ca8.svg";